module.exports = __webpack_public_path__ + "static/Hero-66c1b3e45382ba39f20af83f76d8e5a9.jpg";